import * as Cesium from 'cesium';
export const STORAGE_KEY = 'landscope_unsaved_paths';
export const serializePathsForStorage = (paths, projectId, existingJson) => {
    let existingItems = [];
    if (existingJson) {
        try {
            existingItems = JSON.parse(existingJson);
        }
        catch ( /* ignore */_a) { /* ignore */ }
    }
    const otherProjectItems = existingItems.filter(item => item.projectId !== projectId);
    const currentProjectItems = [];
    paths.forEach((p) => {
        const points = p.points.map(pt => {
            const cart = Cesium.Cartographic.fromCartesian(pt.position);
            return {
                lat: Cesium.Math.toDegrees(cart.latitude),
                lng: Cesium.Math.toDegrees(cart.longitude)
            };
        });
        currentProjectItems.push({
            id: p.id,
            name: p.name,
            points,
            color: p.color,
            displayUnit: p.displayUnit,
            projectId: p.projectId,
            showMeasurements: p.showMeasurements
        });
    });
    return [...otherProjectItems, ...currentProjectItems];
};
export const deserializeStoredPaths = (stored, projectId) => {
    return stored
        .filter(s => s.projectId === projectId)
        .map(s => ({
        id: s.id,
        name: s.name,
        color: s.color,
        unit: s.displayUnit,
        points: s.points.map(pt => ({ latitude: pt.lat, longitude: pt.lng })),
        projectId: s.projectId,
        showMeasurements: s.showMeasurements
    }));
};
